import styled, { css } from 'styled-components';
import { colors, s8 } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';

const DotShape = styled.div<{ $isSelected: boolean }>`
  cursor: pointer;
  height: ${s8};
  border-radius: 100px;
  background-color: ${({ $isSelected }) =>
    $isSelected ? colors.iconStrong : colors.iconOnInverted};
  transition:
    width 0.4s cubic-bezier(0.16, 1, 0.3, 1),
    background-color 0.3s;
  ${({ $isSelected }) =>
    $isSelected
      ? css`
          width: 24px;
        `
      : css`
          width: ${s8};
        `}
`;

const Dot = ({
  isSelected,
  onClick,
}: {
  isSelected: boolean;
  onClick: VoidFunction;
}) => <DotShape $isSelected={isSelected} onClick={onClick} />;

export const CarouselStatus = ({
  count,
  setStep,
  currentIndex,
}: {
  count: number;
  setStep: (index: number) => void;
  currentIndex: number;
}) => (
  <FlexBox gap="small">
    {Array.from({ length: count }, (_, index) => (
      <Dot
        key={`featureModalDot${index}`}
        isSelected={index === currentIndex}
        onClick={() => setStep(index)}
      />
    ))}
  </FlexBox>
);
